<header>
<app-header></app-header>
</header>
<app-sidemenu></app-sidemenu>
<app-breadcrumb></app-breadcrumb>
<router-outlet></router-outlet>
<app-modal-nfa></app-modal-nfa>
<footer>
<app-rodape></app-rodape>
</footer>